export default __webpack_public_path__ + "static/media/sg-grey.997f3bdd.svg";